import { UrlSetState } from '../interfaces/UrlSet';

export function isCrawlInProgress(state: UrlSetState): boolean {
	return (
		state === UrlSetState.NEW ||
		state === UrlSetState.RUNNING ||
		state === UrlSetState.PENDING ||
		state === UrlSetState.STOPPING
	);
}

export function isCrawlDone(state: UrlSetState): boolean {
	return state === UrlSetState.DONE;
}

export function isCrawlFailed(state: UrlSetState): boolean {
	return state === UrlSetState.FAILED;
}
